/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../../config/api';
import { services } from '../../services';
import { Button } from '../ui/button';

const UsersPage: React.FC = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState<any[]>([]);
  const [usersLoading, setUsersLoading] = useState(false);
  // const [totalUsers, setTotalUsers] = useState(0);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewingUser, setViewingUser] = useState<any>(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [userToDelete, setUserToDelete] = useState<any>(null);

  // Pagination states for users
  const [usersCurrentPage, setUsersCurrentPage] = useState(1);
  const [usersTotalPages, setUsersTotalPages] = useState(1);
  const [usersPerPage] = useState(10);

  const fetchUsers = async (page: number = 1) => {
    setUsersLoading(true);
    try {
      const response = await services.get(
        `${API_ENDPOINTS.USERS.LIST}?page=${page}&limit=${usersPerPage}`
      );
      const responseData = response.data;

      console.log('Users API Response:', responseData);

      // Extract data and pagination info from your API response format
      const usersData = responseData.data || [];
      const paginationInfo = {
        total: responseData.total,
        pages: responseData.pages,
        page: responseData.page,
        count: responseData.count,
      };

      console.log('Users Pagination Info:', paginationInfo);
      console.log('Users Data:', usersData);

      setUsers(usersData);
      setUsersTotalPages(paginationInfo.pages);
      setUsersCurrentPage(paginationInfo.page);

      // Count active users (role === 'user' and deletedAt is null)
      // const activeUsers = usersData.filter((user: any) => user.role === 'user' && !user.deletedAt);
      // setTotalUsers(activeUsers.length);
    } catch (err: any) {
      console.error('Failed to fetch users:', err);
      if (err.status === 401 || err.data?.message?.includes('Not authorized')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
        return;
      }
    } finally {
      setUsersLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  // View user functions
  const handleViewUser = (user: any) => {
    setViewingUser(user);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewingUser(null);
  };

  // Delete user functions
  const handleDeleteUser = (user: any) => {
    setUserToDelete(user);
    setShowDeleteConfirm(true);
  };

  const confirmDeleteUser = async () => {
    if (!userToDelete) return;

    try {
      await services.delete(API_ENDPOINTS.USERS.DELETE(userToDelete._id || userToDelete.id));
      fetchUsers();
      setShowDeleteConfirm(false);
      setUserToDelete(null);
    } catch (err: any) {
      console.error('Failed to delete user:', err);
      if (err.status === 401 || err.data?.message?.includes('Not authorized')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
        return;
      }
    }
  };

  const cancelDeleteUser = () => {
    setShowDeleteConfirm(false);
    setUserToDelete(null);
  };

  // Pagination handler for users
  const handleUsersPageChange = (page: number) => {
    setUsersCurrentPage(page);
    fetchUsers(page);
  };

  return (
    <div>
      {/* Header with Total Users */}
      <div className='flex flex-col md:flex-row md:items-center md:justify-between mb-8'>
        <div>
          <h2
            className='text-3xl font-bold mb-2 font-dm-serif'
            style={{
              color: '#ede8c5',
              textShadow: '0 2px 6px rgba(0, 0, 0, 0.4), 0 0 10px rgba(187, 228, 37, 0.2)',
              letterSpacing: '0.5px',
            }}
          >
            Learn Users Management
          </h2>
          <p className='font-work-sans' style={{ color: '#ede8c5' }}>
            Manage and view all registered Learn users
          </p>
        </div>

        {/* Total Users Card - Right Side
        <div className='mt-4 md:mt-0'>
          <div
            className='rounded-lg p-6 border shadow-lg transition-all duration-300 hover:scale-105'
            style={{
              backgroundColor: '#0B222C',
              borderColor: '#095D52',
              boxShadow:
                '0 8px 25px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(187, 228, 37, 0.2), inset 0 1px 0 rgba(187, 228, 37, 0.1)',
              backgroundImage:
                'linear-gradient(135deg, rgba(187, 228, 37, 0.05) 0%, rgba(9, 93, 82, 0.1) 50%, rgba(11, 34, 44, 0.95) 100%)',
            }}
          >
            <div className='flex items-center'>
              <div
                className='p-3 rounded-lg mr-4 transition-all duration-300 hover:scale-110'
                style={{
                  backgroundColor: '#095D52',
                  boxShadow: '0 4px 15px rgba(9, 93, 82, 0.4), 0 0 0 1px rgba(187, 228, 37, 0.3)',
                  backgroundImage:
                    'linear-gradient(135deg, rgba(187, 228, 37, 0.1) 0%, rgba(9, 93, 82, 0.8) 100%)',
                }}
              >
                <svg
                  className='w-6 h-6'
                  style={{ color: '#ede8c5' }}
                  fill='currentColor'
                  viewBox='0 0 20 20'
                >
                  <path d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' />
                </svg>
              </div>
              <div>
                <p className='text-sm font-medium font-work-sans' style={{ color: '#ede8c5' }}>
                  Total Users
                </p>
                <p className='text-2xl font-bold font-dm-serif' style={{ color: '#ede8c5' }}>
                  {totalUsers}
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {usersLoading ? (
        <div className='flex items-center justify-center py-12'>
          <div className='text-center'>
            <div
              className='animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4'
              style={{ borderColor: '#095D52' }}
            ></div>
            <p className='text-lg font-work-sans' style={{ color: '#ede8c5' }}>
              Loading users...
            </p>
          </div>
        </div>
      ) : (
        <div
          className='rounded-lg overflow-hidden shadow-lg transition-all duration-300'
          style={{
            backgroundColor: '#0B222C',
            border: '2px solid #095D52',
            boxShadow:
              '0 8px 25px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(187, 228, 37, 0.2), inset 0 1px 0 rgba(187, 228, 37, 0.1)',
            backgroundImage:
              'linear-gradient(135deg, rgba(187, 228, 37, 0.03) 0%, rgba(9, 93, 82, 0.05) 50%, rgba(11, 34, 44, 0.98) 100%)',
          }}
        >
          <div className='overflow-x-auto'>
            <table className='min-w-full'>
              <thead
                style={{
                  backgroundColor: '#095D52',
                  backgroundImage:
                    'linear-gradient(135deg, rgba(187, 228, 37, 0.1) 0%, rgba(9, 93, 82, 0.8) 100%)',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                }}
              >
                <tr>
                  <th
                    className='px-6 py-4 text-left text-xs font-bold uppercase tracking-wider font-work-sans'
                    style={{ color: '#ede8c5' }}
                  >
                    Name
                  </th>
                  <th
                    className='px-6 py-4 text-left text-xs font-bold uppercase tracking-wider font-work-sans'
                    style={{ color: '#ede8c5' }}
                  >
                    Email
                  </th>
                  <th
                    className='px-6 py-4 text-left text-xs font-bold uppercase tracking-wider font-work-sans'
                    style={{ color: '#ede8c5' }}
                  >
                    Role
                  </th>
                  <th
                    className='px-6 py-4 text-left text-xs font-bold uppercase tracking-wider font-work-sans'
                    style={{ color: '#ede8c5' }}
                  >
                    Status
                  </th>
                  <th
                    className='px-6 py-4 text-left text-xs font-bold uppercase tracking-wider font-work-sans'
                    style={{ color: '#ede8c5' }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: '#0B222C' }} className='divide-y divide-gray-700'>
                {users
                  .filter((user: any) => user.role === 'user' && !user.deletedAt)
                  .map((user: any) => (
                    <tr
                      key={user._id || user.id}
                      className='transition-colors'
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#095D52')}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                    >
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <div
                          className='text-sm font-medium font-work-sans'
                          style={{ color: '#ede8c5' }}
                        >
                          {String(user.firstName || '')} {String(user.lastName || '')}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <div className='text-sm font-work-sans' style={{ color: '#ede8c5' }}>
                          {String(user.email || '')}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <span
                          className='inline-flex px-3 py-1 text-xs font-semibold rounded-full font-work-sans'
                          style={{ backgroundColor: '#095D52', color: '#ede8c5' }}
                        >
                          {String(user.role || '')}
                        </span>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <span
                          className='inline-flex px-3 py-1 text-xs font-semibold rounded-full font-work-sans'
                          style={{
                            backgroundColor: user.isActive ? '#10B981' : '#EF4444',
                            color: '#ede8c5',
                          }}
                        >
                          {user.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <div className='flex space-x-2'>
                          <button
                            onClick={() => handleViewUser(user)}
                            className='p-2 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none'
                            style={{
                              backgroundColor: '#0B222C',
                              border: '1px solid #095D52',
                              color: '#ede8c5',
                              boxShadow:
                                '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#095D52';
                              e.currentTarget.style.borderColor = '#bbe425';
                              e.currentTarget.style.boxShadow =
                                '0 4px 15px rgba(9, 93, 82, 0.4), 0 0 0 1px rgba(187, 228, 37, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#0B222C';
                              e.currentTarget.style.borderColor = '#095D52';
                              e.currentTarget.style.boxShadow =
                                '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)';
                            }}
                            title='View User Details'
                          >
                            <svg
                              className='w-4 h-4'
                              fill='none'
                              stroke='currentColor'
                              viewBox='0 0 24 24'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
                              />
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
                              />
                            </svg>
                          </button>
                          <button
                            onClick={() => handleDeleteUser(user)}
                            className='p-2 rounded-lg transition-all duration-200 hover:scale-105 focus:outline-none'
                            style={{
                              backgroundColor: '#0B222C',
                              border: '1px solid #095D52',
                              color: '#ede8c5',
                              boxShadow:
                                '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#EF4444';
                              e.currentTarget.style.borderColor = '#DC2626';
                              e.currentTarget.style.boxShadow =
                                '0 4px 15px rgba(239, 68, 68, 0.4), 0 0 0 1px rgba(220, 38, 38, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#0B222C';
                              e.currentTarget.style.borderColor = '#095D52';
                              e.currentTarget.style.boxShadow =
                                '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)';
                            }}
                            title='Delete User'
                          >
                            <svg
                              className='w-4 h-4'
                              fill='none'
                              stroke='currentColor'
                              viewBox='0 0 24 24'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
                              />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Users Pagination */}
      {!usersLoading && usersTotalPages > 1 && (
        <div className='mt-8' style={{ borderTop: '2px solid #095D52' }}>
          <div className='flex justify-between items-center pt-6'>
            <div className='text-sm font-work-sans' style={{ color: '#ede8c5' }}>
              Page {usersCurrentPage} of {usersTotalPages} • Showing{' '}
              {(usersCurrentPage - 1) * usersPerPage + 1} to{' '}
              {Math.min(usersCurrentPage * usersPerPage, users.length)} of {users.length} users
            </div>

            <div className='flex space-x-3'>
              <button
                onClick={() => handleUsersPageChange(usersCurrentPage - 1)}
                disabled={usersCurrentPage === 1}
                className='flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-work-sans'
                style={{
                  backgroundColor: usersCurrentPage === 1 ? '#095D5250' : '#0B222C',
                  border: '1px solid #095D52',
                  color: '#ede8c5',
                  boxShadow:
                    usersCurrentPage === 1
                      ? 'none'
                      : '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)',
                }}
                onMouseEnter={(e) => {
                  if (usersCurrentPage !== 1) {
                    e.currentTarget.style.backgroundColor = '#095D52';
                    e.currentTarget.style.borderColor = '#bbe425';
                    e.currentTarget.style.boxShadow =
                      '0 4px 15px rgba(9, 93, 82, 0.4), 0 0 0 1px rgba(187, 228, 37, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (usersCurrentPage !== 1) {
                    e.currentTarget.style.backgroundColor = '#0B222C';
                    e.currentTarget.style.borderColor = '#095D52';
                    e.currentTarget.style.boxShadow =
                      '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)';
                  }
                }}
              >
                <svg className='w-4 h-4 mr-2' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M15 19l-7-7 7-7'
                  />
                </svg>
                Previous
              </button>

              <button
                onClick={() => handleUsersPageChange(usersCurrentPage + 1)}
                disabled={usersCurrentPage === usersTotalPages}
                className='flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-work-sans'
                style={{
                  backgroundColor: usersCurrentPage === usersTotalPages ? '#095D5250' : '#0B222C',
                  border: '1px solid #095D52',
                  color: '#ede8c5',
                  boxShadow:
                    usersCurrentPage === usersTotalPages
                      ? 'none'
                      : '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)',
                }}
                onMouseEnter={(e) => {
                  if (usersCurrentPage !== usersTotalPages) {
                    e.currentTarget.style.backgroundColor = '#095D52';
                    e.currentTarget.style.borderColor = '#bbe425';
                    e.currentTarget.style.boxShadow =
                      '0 4px 15px rgba(9, 93, 82, 0.4), 0 0 0 1px rgba(187, 228, 37, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (usersCurrentPage !== usersTotalPages) {
                    e.currentTarget.style.backgroundColor = '#0B222C';
                    e.currentTarget.style.borderColor = '#095D52';
                    e.currentTarget.style.boxShadow =
                      '0 2px 8px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(187, 228, 37, 0.1)';
                  }
                }}
              >
                Next
                <svg className='w-4 h-4 ml-2' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M9 5l7 7-7 7'
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View User Modal */}
      {showViewModal && viewingUser && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
          <div
            className='rounded-xl border max-w-lg w-full mx-4 shadow-lg'
            style={{
              backgroundColor: '#0B222C',
              borderColor: '#095D52',
              boxShadow:
                '0 8px 25px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(187, 228, 37, 0.2), inset 0 1px 0 rgba(187, 228, 37, 0.1)',
              backgroundImage:
                'linear-gradient(135deg, rgba(187, 228, 37, 0.03) 0%, rgba(9, 93, 82, 0.05) 50%, rgba(11, 34, 44, 0.98) 100%)',
            }}
          >
            <div className='p-6'>
              <div className='flex justify-between items-center mb-6'>
                <h2
                  className='text-2xl font-bold font-dm-serif'
                  style={{
                    color: '#ede8c5',
                    textShadow: '0 2px 8px rgba(0, 0, 0, 0.5), 0 0 15px rgba(187, 228, 37, 0.3)',
                    letterSpacing: '0.8px',
                  }}
                >
                  User Details
                </h2>
                <button
                  onClick={closeViewModal}
                  className='text-2xl transition-all duration-300 hover:scale-110'
                  style={{ color: '#ede8c5' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#bbe425')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#ede8c5')}
                >
                  ×
                </button>
              </div>

              <div className='space-y-4'>
                <div>
                  <label
                    className='block text-sm font-medium font-work-sans mb-2'
                    style={{ color: '#ede8c5' }}
                  >
                    Full Name
                  </label>
                  <div
                    className='w-full px-3 py-2 rounded-md font-work-sans'
                    style={{
                      backgroundColor: '#0B222C',
                      border: '1px solid #095D52',
                      color: '#ede8c5',
                      boxShadow:
                        '0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(187, 228, 37, 0.05)',
                    }}
                  >
                    {String(viewingUser.firstName || '')} {String(viewingUser.lastName || '')}
                  </div>
                </div>

                <div>
                  <label
                    className='block text-sm font-medium font-work-sans mb-2'
                    style={{ color: '#ede8c5' }}
                  >
                    Email
                  </label>
                  <div
                    className='w-full px-3 py-2 rounded-md font-work-sans'
                    style={{
                      backgroundColor: '#0B222C',
                      border: '1px solid #095D52',
                      color: '#ede8c5',
                      boxShadow:
                        '0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(187, 228, 37, 0.05)',
                    }}
                  >
                    {String(viewingUser.email || '')}
                  </div>
                </div>

                <div>
                  <label
                    className='block text-sm font-medium font-work-sans mb-2'
                    style={{ color: '#ede8c5' }}
                  >
                    Role
                  </label>
                  <div
                    className='w-full px-3 py-2 rounded-md font-work-sans'
                    style={{
                      backgroundColor: '#0B222C',
                      border: '1px solid #095D52',
                      color: '#ede8c5',
                      boxShadow:
                        '0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(187, 228, 37, 0.05)',
                    }}
                  >
                    {String(viewingUser.role || '')}
                  </div>
                </div>

                <div>
                  <label
                    className='block text-sm font-medium font-work-sans mb-2'
                    style={{ color: '#ede8c5' }}
                  >
                    Status
                  </label>
                  <div
                    className='w-full px-3 py-2 rounded-md font-work-sans'
                    style={{
                      backgroundColor: '#0B222C',
                      border: '1px solid #095D52',
                      color: '#ede8c5',
                      boxShadow:
                        '0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(187, 228, 37, 0.05)',
                    }}
                  >
                    {viewingUser.isActive ? 'Active' : 'Inactive'}
                  </div>
                </div>

                {viewingUser.createdAt && (
                  <div>
                    <label
                      className='block text-sm font-medium font-work-sans mb-2'
                      style={{ color: '#ede8c5' }}
                    >
                      Created At
                    </label>
                    <div
                      className='w-full px-3 py-2 rounded-md font-work-sans'
                      style={{
                        backgroundColor: '#0B222C',
                        border: '1px solid #095D52',
                        color: '#ede8c5',
                      }}
                    >
                      {new Date(viewingUser.createdAt).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </div>
                  </div>
                )}

                {viewingUser.updatedAt && (
                  <div>
                    <label
                      className='block text-sm font-medium font-work-sans mb-2'
                      style={{ color: '#ede8c5' }}
                    >
                      Last Updated
                    </label>
                    <div
                      className='w-full px-3 py-2 rounded-md font-work-sans'
                      style={{
                        backgroundColor: '#0B222C',
                        border: '1px solid #095D52',
                        color: '#ede8c5',
                      }}
                    >
                      {new Date(viewingUser.updatedAt).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div className='flex justify-end pt-4'>
                <Button
                  type='button'
                  onClick={closeViewModal}
                  className='font-work-sans transition-all duration-300 hover:scale-105'
                  style={{
                    backgroundColor: '#095D52',
                    color: '#ede8c5',
                    border: '1px solid #095D52',
                    boxShadow: '0 4px 15px rgba(9, 93, 82, 0.4), 0 0 0 1px rgba(187, 228, 37, 0.3)',
                    backgroundImage:
                      'linear-gradient(135deg, rgba(187, 228, 37, 0.1) 0%, rgba(9, 93, 82, 0.8) 100%)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#bbe425';
                    e.currentTarget.style.boxShadow =
                      '0 6px 20px rgba(187, 228, 37, 0.5), 0 0 0 1px rgba(187, 228, 37, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#095D52';
                    e.currentTarget.style.boxShadow =
                      '0 4px 15px rgba(9, 93, 82, 0.4), 0 0 0 1px rgba(187, 228, 37, 0.3)';
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete User Confirmation Modal */}
      {showDeleteConfirm && userToDelete && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
          <div
            className='rounded-xl border max-w-md w-full mx-4 shadow-lg'
            style={{
              backgroundColor: '#0B222C',
              borderColor: '#095D52',
              boxShadow:
                '0 8px 25px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(187, 228, 37, 0.2), inset 0 1px 0 rgba(187, 228, 37, 0.1)',
              backgroundImage:
                'linear-gradient(135deg, rgba(187, 228, 37, 0.03) 0%, rgba(9, 93, 82, 0.05) 50%, rgba(11, 34, 44, 0.98) 100%)',
            }}
          >
            <div className='p-6'>
              <div className='flex items-center mb-4'>
                <div className='flex-shrink-0'>
                  <svg
                    className='w-8 h-8'
                    style={{ color: '#EF4444' }}
                    fill='currentColor'
                    viewBox='0 0 20 20'
                  >
                    <path
                      fillRule='evenodd'
                      d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z'
                      clipRule='evenodd'
                    />
                  </svg>
                </div>
                <div className='ml-3'>
                  <h3 className='text-lg font-medium font-dm-serif' style={{ color: '#ede8c5' }}>
                    Delete User
                  </h3>
                </div>
              </div>

              <div className='mb-6'>
                <p className='text-sm font-work-sans' style={{ color: '#ede8c5' }}>
                  Are you sure you want to delete{' '}
                  <span className='font-semibold' style={{ color: '#ede8c5' }}>
                    "{String(userToDelete.firstName || '')} {String(userToDelete.lastName || '')}"
                  </span>
                  ?
                </p>
              </div>

              <div className='flex space-x-3'>
                <button
                  onClick={cancelDeleteUser}
                  className='flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 font-work-sans'
                  style={{
                    backgroundColor: '#095D52',
                    color: '#ede8c5',
                    border: '1px solid #095D52',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#bbe425')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#095D52')}
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDeleteUser}
                  className='flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 font-work-sans'
                  style={{ backgroundColor: '#EF4444', color: '#ede8c5' }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#DC2626')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#EF4444')}
                >
                  Delete User
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersPage;
